var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 187,
    viewBox: "0 0 289 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.488 12.0889L223.078 37.6228L236.788 22.6117L288.198 24.0676L232.488 12.0889Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M223.369 0.47168C223.369 0.47168 233.809 9.51852 232.389 12.3902L287.709 23.7766C287.699 23.7766 261.089 5.04028 223.369 0.47168Z",
    fill: "#FF5F3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222.659 38.1149C222.229 38.9282 243.629 35.926 243.629 35.926L236.289 22.3105C236.289 22.3105 226.449 30.9959 222.659 38.1149Z",
    fill: "#FFBF08"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M236.289 22.3107C236.289 22.3107 246.349 38.838 240.719 48.4371L288.589 23.9875C288.589 23.9875 241.379 21.3367 236.289 22.3107Z",
    fill: "#FF5F3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83203 140.585C2.50438 163.085 21.8304 183.602 44.1983 185.133C66.5663 186.664 88.6473 168.634 91.3285 146.282C91.9927 140.725 91.5007 134.764 88.4341 130.088C85.3675 125.411 79.2344 122.481 73.995 124.415C68.0914 126.589 65.5004 134.245 67.4764 140.239C69.4607 146.233 74.9133 150.514 80.7759 152.802C93.198 157.652 108.35 154.4 117.706 144.866C128.234 134.13 130.587 118.092 134.564 103.57C143.28 71.6917 157.99 22.3188 205.981 26.6987",
    stroke: "#FFBF08",
    strokeWidth: 2.45982,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.56 6.56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKite);
export default __webpack_public_path__ + "static/media/kite.4ec688288961000e171c3352311925c6.svg";
export { ForwardRef as ReactComponent };